import Vue from 'vue'
import _ from 'lodash'
import store from '../store/store'
import { allPermissionAccount } from '../const'

Vue.prototype._ = _
Vue.prototype.p = module =>
  store.getters[`user/auth`](module) ||
  store.getters[`user/user`](allPermissionAccount)

Vue.prototype.$permission = function(value) {
  let result =
    store.getters[`user/auth`](value) ||
    store.getters[`user/user`](allPermissionAccount)
  return result
}

export default {}
